import type { FaireProductEntity } from "../../entity_types/product";

export const p_cst8bpsuqs: FaireProductEntity = {
  token: "p_cst8bpsuqs",
  type: "product",
  name: "Hair Repair 10oz (pump not included) Reusable packaging",
  brandToken: "b_8777nmps",
  brandName: "Plaine Products",
  imageUrl:
    "https://cdn.faire.com/fastly/e7a5b9e13c87d60ab7b16a78864e5bb140ff5bcff7221dd2c94f83aa30f136fb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/56c0e43c3e1d2986205abe10a62d90b00da8e4820c1483d0a9f33b1c2867897a.jpeg",
    "https://cdn.faire.com/fastly/b250b179f5cdd02d84080bfaa6449332e47e0beff85d4c273b4f2ffa564680d8.jpeg",
    "https://cdn.faire.com/fastly/fdedeb6e2fc4e6e489cd5f96587448f74d96ff42bfb75c131a1519a705e30b8a.jpeg",
  ],
  priceDollars: 19,
  description:
    "Apply this lightweight formula to damp or dry hair focusing on the ends to replenish moisture. Use as often as needed to detangle hair, repair split ends and enjoy smoother, softer, and shinier hair.\n\nThis versatile product can also be used before going in the sun or the pool to prevent drying; on second-day hair to revitalize curls; and to detangle hair. To use as a detangler, spray on damp hair after washing. Always start from the ends, use a wide-tooth comb, and work your way up when detangling wet hair to prevent breakage. \n\nThe aluminum bottles can be returned for free to be washed and reused. \n\nThis product is:\nFree of sulfates, parabens, phthalates and palm oil\nVegan and have non GMO ingredients\nDesigned to biodegrade\nBaby safe and hypoallergenic \nCruelty Free, Leaping Bunny certified \nScented with a natural derived fragrance, not synthetic fragrances\nFree of single-use plastic\n\nIncludes 10 oz aluminum bottle of Hair Repair. Compatible with medium spray pump.",
  tags: [],
  msrpDollars: 38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:36.328Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
